import { EntitiesStore } from './entities-store.abstract';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
/**
 * Stats of  members
 *
 * @export
 * @interface SeasonMembersStats
 */
export interface SeasonMembersStats {
  DivCode: string;
  AverageArr: number;
  MatchWinPercentage: number;
}

/**
 * Store fore getting the members stats
 *
 * @export
 * @class MembersAssociationsStatsStore
 * @extends {EntitiesStore<SeasonMembersStats>}
 */
export class MembersAssociationsStatsStore extends EntitiesStore<SeasonMembersStats> {
  constructor(http: HttpClient, dependencies:Array<any>) {
    super('MEMBERASSOCIATIONSTATS', http, dependencies);
  }
}
